// Mock data pro UniqueCreative s.r.o. landing page

export const companyInfo = {
  name: "UniqueCreative",
  fullName: "UniqueCreative s.r.o.",
  tagline: "Tvoříme digitální budoucnost",
  description: "Moderní společnost zaměřená na vzdělávání a vývoj softwaru. Pomáháme jednotlivcům i firmám rozvíjet digitální dovednosti a zároveň vytváříme praktická softwarová řešení.",
  parentCompany: "Součást skupiny vzdělávací agentury GAVITO technic s.r.o.",
  ico: "19876815",
  address: "Rybná 716/24, Staré Město, 110 00 Praha",
  phone: "+420 739 921 359",
  email: "info@uniquecreative.cz"
};

export const aboutContent = {
  title: "O nás",
  subtitle: "Kdo jsme",
  paragraphs: [
    "UniqueCreative s.r.o. je moderní společnost zaměřená na vzdělávání a vývoj softwaru.",
    "Pomáháme jednotlivcům i firmám rozvíjet digitální dovednosti a zároveň vytváříme praktická softwarová řešení, která zjednodušují práci, šetří čas a podporují růst.",
    "Věříme, že technologie by měla sloužit lidem – ne naopak. Proto se zaměřujeme na intuitivní a efektivní řešení."
  ],
  highlights: [
    { label: "Vzdělávání", description: "Rozvíjíme digitální dovednosti" },
    { label: "Software", description: "Vytváříme praktická řešení" },
    { label: "Inovace", description: "Podporujeme růst a efektivitu" }
  ]
};

export const contactContent = {
  title: "Kontakt",
  subtitle: "Spojte se s námi"
};
